import {
    Avatar,
    Chip,
    Icon,
    IconButton,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { UserDto, UserRole } from "../../api/identity";
import { toJalaliDate } from "../../utils/date";

export default function User(props: { user: UserDto }) {
    const navigate = useNavigate();

    const goToUpdateUser = () => {
        navigate(`/user/update/${props.user.id}`);
    };

    const goToDeleteUser = () => {
        navigate(`/user/delete/${props.user.id}`);
    };

    return (
        <Paper sx={{ width: "100%" }}>
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ p: 1 }}
            >
                <Avatar src={props.user.avatarUrl} />

                <Stack spacing={1} flexGrow={1}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography color="text.primary">
                            {props.user.displayName}
                        </Typography>

                        {props.user.role === UserRole.ADMINISTRATOR && (
                            <Chip
                                size="small"
                                color="success"
                                label="صاحب حساب"
                            />
                        )}
                    </Stack>

                    <Typography color="text.secondary" fontSize="smaller">
                        آخرین تاریخ ورود:{" "}
                        {toJalaliDate(props.user.lastLoginDate) ?? "-"}
                    </Typography>
                </Stack>

                <IconButton onClick={goToDeleteUser}>
                    <Icon color="warning">delete</Icon>
                </IconButton>

                <IconButton onClick={goToUpdateUser}>
                    <Icon>edit</Icon>
                </IconButton>
            </Stack>
        </Paper>
    );
}
